import {
  currentOrganizerReturnPath,
  isOnOrganizerSignInPage,
  organizerSignInPath,
} from "./organizer-return-url";

/** When true, **401** does not trigger navigation (unit tests). */
let redirectOnUnauthorizedDisabled = false;

/** Disables **401** redirect for tests; returns a restore function. */
export function disableOrganizerSessionRedirectForTests(): () => void {
  redirectOnUnauthorizedDisabled = true;
  return () => {
    redirectOnUnauthorizedDisabled = false;
  };
}

function maybeRedirectToSignIn(): void {
  if (redirectOnUnauthorizedDisabled) {
    return;
  }
  if (typeof window === "undefined") {
    return;
  }
  if (isOnOrganizerSignInPage()) {
    return;
  }
  const dest = organizerSignInPath(currentOrganizerReturnPath());
  window.location.assign(dest);
}

/**
 * **fetch** for organizer session APIs; redirects to sign-in on **401**.
 *
 * @param input - Request URL or **Request**.
 * @param init - Optional fetch init (**credentials** default **same-origin**).
 */
export async function organizerSessionFetch(
  input: RequestInfo | URL,
  init?: RequestInit,
): Promise<Response> {
  const res = await fetch(input, {
    ...init,
    credentials: init?.credentials ?? "same-origin",
  });
  if (res.status === 401) {
    maybeRedirectToSignIn();
  }
  return res;
}
